import { useMemo } from 'react';
import { Video } from '../MediaItemList';

export const useMediaGallery = (media: Array<File | Video>) =>
  useMemo(
    () =>
      media.map((mediaItem) => {
        if (mediaItem instanceof File) {
          const objectUrl = URL.createObjectURL(mediaItem);

          const type = mediaItem.type.split('/')[0];

          return {
            type,
            url: objectUrl,
            name: mediaItem.name,
            size: mediaItem.size,
          };
        }

        const name = new URL(mediaItem.url).pathname.substring(1);

        return {
          ...mediaItem,
          name,
          size: 0,
        };
      }),
    [media],
  );
